<template>
  <div>
    <vx-card>
      <el-row>
        <el-col>
          <el-tabs>
            <el-tab-pane :label="$t('create')">
              <el-row type="flex" justify="space-between">
                <el-col :span="11">
                  <el-form
                    ref="form"
                    label-width="30%"
                    label-position="left"
                    size="mini"
                  >
                    <el-form-item label="NO REGISTRATION">
                      <span slot="label">
                        {{ $t("noRegistration").toUpperCase()
                        }}<span style="color: red">*</span></span
                      >
                      <el-input
                        v-model="form.noReg"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>

                    <el-form-item label="DEPARTMENT">
                      <span slot="label"
                        >{{ $t("dept").toUpperCase()
                        }}<span style="color: red">*</span></span
                      >
                      <el-select
                        style="width: 100%"
                        v-model="form.department"
                        filterable
                        disabled
                        placeholder="Select"
                      >
                        <el-option
                          v-for="item in optionDepartment"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>

                <el-col :span="11">
                  <el-form
                    ref="form"
                    label-width="30%"
                    label-position="left"
                    size="small"
                  >
                    <el-form-item label="DATE">
                      <span slot="label"
                        >{{ $t("tanggal").toUpperCase()
                        }}<span style="color: red">*</span></span
                      >
                      <DatePicker
                        size="small"
                        style="width: 100%"
                        :shortcuts="shortcuts"
                        :format="$formatDate"
                        :value="form.tanggal"
                        type="date"
                        placeholder="Select date"
                        v-model="form.tanggal"
                      ></DatePicker>
                    </el-form-item>
                    <el-form-item :label="$t('remark').toUpperCase()">
                      <el-input
                        v-model="form.remark"
                        style="width: 100%"
                      ></el-input>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="11">
                  <el-form
                    ref="form"
                    label-width="30%"
                    label-position="left"
                    size="small"
                  >
                    <el-form-item label="TUJUAN">
                      <span slot="label"
                        >{{ $t("tujuan").toUpperCase()
                        }}<span style="color: red">*</span></span
                      >
                      <el-select
                        style="width: 100%"
                        v-model="form.tujuan"
                        filterable
                        placeholder="Select"
                        @change="inputTujuan"
                      >
                        <el-option
                          v-for="item in optionDepartment"
                          :key="item.value"
                          :label="item.text"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
              <div>
                <span
                  >{{ $t("tanda").toUpperCase() }}
                  <span style="color: red">*</span>
                  {{ $t("harusdiisi").toUpperCase() }}</span
                >
              </div>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>

      <el-row class="mt-2">
        <el-col>
          <vxe-toolbar size="small">
            <template v-slot:buttons>
              <el-button
                v-if="$store.state.produksi != 'warehouse'"
                type="primary"
                size="mini"
                icon="el-icon-search"
                v-on:click="modalResult = true"
                >{{ $t("selectResultProd") }}</el-button
              >
              <el-button
                v-if="$store.state.produksi == 'warehouse'"
                type="primary"
                size="mini"
                icon="el-icon-search"
                v-on:click="$refs.modalReceiving.open()"
                >{{ $t("selectWHReceive") }}</el-button
              >

              <!-- <el-popconfirm
                    confirm-button-text="OK"
                    cancel-button-text="No, Thanks"
                    icon="el-icon-info"
                    icon-color="red"
                    title="Are you sure want to delete the data?"
                    @confirm="detailtoisdeletedTrue"
                  >
                    <el-button
                      class="ml-3"
                      slot="reference"
                      type="danger"
                      icon="el-icon-delete"
                      >Delete Data</el-button
                    >
                  </el-popconfirm> -->
            </template>

            <template v-slot:tools>
              <el-button
                type="primary"
                icon="el-icon-back"
                @click.prevent="back"
                size="mini"
                >{{ $t("back") }}</el-button
              >

              <el-button
                size="mini"
                type="primary"
                icon="el-icon-circle-check"
                :disabled="baca.length <= 0"
                @click.prevent="approvePin"
                >{{ $t("simpan") }}</el-button
              >
            </template>
          </vxe-toolbar>
          <vxe-table
            size="mini"
            :loading="loadingTable"
            empty-text="Empty Data "
            keep-source
            border
            resizable
            :row-style="rowStyle"
            show-overflow
            show-header-overflow
            show-footer
            :footer-method="footerMethod"
            ref="xTable"
            height="400"
            row-key
            highlight-hover-row
            highlight-current-row
            :row-config="{ isCurrent: true, isHover: true, height: 35 }"
            :column-config="{ resizable: true }"
            :data="baca"
            :mouse-config="{ selected: true }"
            :checkbox-config="{
              highlight: true,
              range: true,
            }"
            :keyboard-config="{
              isArrow: true,
              isDel: true,
              isEnter: true,
              isTab: true,
              isEdit: true,
            }"
            :edit-config="{
              trigger: 'dblclick',
              mode: 'cell',
              showStatus: true,
            }"
            :scroll-y="{ mode: 'wheel' }"
            @checkbox-all="getDataSelected"
            @checkbox-change="getDataSelected"
          >
            <vxe-column type="seq" fixed="left" width="60"></vxe-column>

            <vxe-column
              header-align="center  "
              align="center"
              :title="$t('delete').toUpperCase()"
              width="120"
            >
              <template #default="{ row }">
                <template>
                  <el-button
                    @click="hapusRow(row)"
                    size="mini"
                    v-if="!row.isDeleted"
                    type="danger"
                  >
                    {{ $t("delete") }}
                  </el-button>
                  <el-button
                    size="mini"
                    @click="hapusRow(row)"
                    v-else
                    type="warning"
                  >
                    {{ $t("cancel") }}
                  </el-button>
                </template>
              </template>
            </vxe-column>

            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              width="120"
              align="left"
              header-align="center"
              field="noRegProd"
              :title="$t('noRegProd').toUpperCase()"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              width="120"
              align="left"
              header-align="center"
              field="dateProd"
              :formatter="$$formatDate"
              :title="$t('dateProd').toUpperCase()"
              sortable
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
            >
              <template #filter="{ $panel, column }">
                <input
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  style="padding: 5px"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                />
              </template>
            </vxe-column>
            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              width="120"
              align="left"
              header-align="center"
              field="noWo"
              :title="$t('noPO').toUpperCase()"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>

            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              width="160"
              align="left"
              header-align="center"
              field="kodeBarang"
              :title="$t('code').toUpperCase()"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>
            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              width="200"
              align="left"
              header-align="center"
              field="namaBarang"
              :title="$t('deskripsi').toUpperCase()"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>

            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              width="100"
              align="center"
              header-align="center"
              field="satuan"
              :title="$t('satuan').toUpperCase()"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>

            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              align="left"
              header-align="center"
              width="120"
              field="style"
              :title="$store.state.styleName"
              v-if="$store.state.availableStyle"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>
            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              align="left"
              header-align="center"
              width="120"
              field="color"
              :title="$store.state.colorName"
              v-if="$store.state.availableColor"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>
            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              align="left"
              header-align="center"
              width="120"
              field="size"
              :title="$store.state.sizeName"
              v-if="$store.state.availableSize"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>
            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              align="left"
              header-align="center"
              width="120"
              field="spec"
              :title="$store.state.specName"
              v-if="$store.state.availableSpec"
              sortable
            >
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>
            <vxe-column
              :filters="[{ data: '' }]"
              :filter-method="$$filterHeaderTable"
              width="100"
              align="center"
              header-align="center"
              field="hsCode"
              :title="$t('hsCode').toUpperCase()"
              sortable
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  v-model="row.hsCode"
                  size="mini"
                  type="text"
                ></vxe-input>
              </template>
              <template #filter="{ $panel, column }">
                <input
                  style="padding: 5px"
                  type="type"
                  v-for="(option, index) in column.filters"
                  :key="index"
                  v-model="option.data"
                  @input="$panel.changeOption($event, !!option.data, option)"
                /> </template
            ></vxe-column>

            <vxe-column
              width="150"
              align="right"
              header-align="center"
              field="qty"
              :formatter="$$formatAmountBc"
              sortable
              :title="$t('qty').toUpperCase()"
              :edit-render="{ autofocus: '.vxe-input--inner' }"
            >
              <template #edit="{ row }">
                <vxe-input
                  @blur="validationQty(row)"
                  v-model="row.qty"
                  size="mini"
                  type="number"
                ></vxe-input>
              </template>
            </vxe-column>
            <vxe-column
              align="right"
              header-align="center"
              width="140"
              field="jenisDokumenBc"
              :title="$t('asalJenisDokumen')"
              sortable
            >
            </vxe-column>
            <vxe-column
              align="right"
              header-align="center"
              width="140"
              field="nomorDokumenBc"
              :title="$t('asalNomorDokumen')"
              sortable
            >
            </vxe-column>
          </vxe-table>
        </el-col>
      </el-row>
    </vx-card>

    <sweet-modal ref="modalReceiving" width="80%">
      <h3>{{ $t("selectFromReceiving") }} {{ $store.state.produksi }}</h3>
      <vxe-table
        size="mini"
        :loading="loadingTable"
        empty-text="Empty Data "
        keep-source
        border
        show-overflow
        show-header-overflow
        ref="xTableReceiv"
        height="400"
        row-key
        highlight-hover-row
        highlight-current-row
        :row-config="{ isCurrent: true, isHover: true, height: 35 }"
        :column-config="{ resizable: true }"
        :data="dataHalf"
        :mouse-config="{ selected: true }"
        :checkbox-config="{
          highlight: true,
          range: true,
        }"
        :keyboard-config="{
          isArrow: true,
          isDel: true,
          isEnter: true,
          isTab: true,
          isEdit: true,
        }"
        :edit-config="{
          trigger: 'dblclick',
          mode: 'cell',
          showStatus: true,
        }"
        :scroll-y="{ mode: 'wheel' }"
        @checkbox-all="selectedHalf"
        @checkbox-change="selectedHalf"
      >
        <vxe-column type="seq" fixed="left" width="60"></vxe-column>
        <vxe-column type="checkbox" width="60"></vxe-column>
        <vxe-column
          width="130"
          field="tglReceiving"
          header-align="center"
          align="left"
          :formatter="$$formatDate"
          :title="$t('dateReceiving').toUpperCase()"
        >
        </vxe-column>
        <vxe-column
          width="100"
          field="userApprove"
          header-align="center"
          align="left"
          :title="$t('userReceiving').toUpperCase()"
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
        >
          <template #filter="{ $panel, column }">
            <input
              style="margin: 10px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>
        <vxe-column
          width="100"
          field="noWo"
          header-align="center"
          align="left"
          :title="$t('noPO').toUpperCase()"
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
        >
          <template #filter="{ $panel, column }">
            <input
              style="margin: 10px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>
        <vxe-column
          width="100"
          field="kodeBarang"
          header-align="center"
          align="left"
          :title="$t('code').toUpperCase()"
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
        >
          <template #filter="{ $panel, column }">
            <input
              style="margin: 10px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>

        <vxe-column
          width="300"
          field="namaBarang"
          header-align="center"
          align="left"
          :title="$t('deskripsi').toUpperCase()"
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
        >
          <template #filter="{ $panel, column }">
            <input
              style="margin: 10px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>

        <vxe-column
          width="100"
          field="satuan"
          header-align="center"
          align="left"
          :title="$t('satuan').toUpperCase()"
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
        >
          <template #filter="{ $panel, column }">
            <input
              style="margin: 10px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            />
          </template>
        </vxe-column>

        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          align="left"
          header-align="center"
          width="120"
          field="style"
          :title="$store.state.styleName"
          v-if="$store.state.availableStyle"
          sortable
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          align="left"
          header-align="center"
          width="120"
          field="color"
          :title="$store.state.colorName"
          v-if="$store.state.availableColor"
          sortable
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          align="left"
          header-align="center"
          width="120"
          field="size"
          :title="$store.state.sizeName"
          v-if="$store.state.availableSize"
          sortable
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>
        <vxe-column
          :filters="[{ data: '' }]"
          :filter-method="$$filterHeaderTable"
          align="left"
          header-align="center"
          width="120"
          field="spec"
          :title="$store.state.specName"
          v-if="$store.state.availableSpec"
          sortable
        >
          <template #filter="{ $panel, column }">
            <input
              style="padding: 5px"
              type="type"
              v-for="(option, index) in column.filters"
              :key="index"
              v-model="option.data"
              @input="$panel.changeOption($event, !!option.data, option)"
            /> </template
        ></vxe-column>

        <vxe-column
          width="100"
          :formatter="$$formatAmountBc"
          field="qty"
          header-align="center"
          align="left"
          :title="$t('qtyReceiving').toUpperCase()"
        >
        </vxe-column>
        <vxe-column
          width="100"
          :formatter="$$formatAmountBc"
          field="qtyUse"
          header-align="center"
          align="left"
          :title="$t('qtyUse').toUpperCase()"
        >
        </vxe-column>
        <vxe-column
          width="100"
          field="total"
          header-align="center"
          align="left"
          :title="$t('qtyBalance').toUpperCase()"
        >
          <template #default="{ row }">
            <span>{{ $formatAngka(row.qty - row.qtyUse) }}</span>
          </template>
        </vxe-column>
      </vxe-table>

      <vs-button
        vs-align="right"
        vs-justify="right"
        v-on:click="$refs.modalReceiving.close()"
      >
        {{ $t("close") }}
      </vs-button>
    </sweet-modal>

    <vxe-modal
      ref="modalResult"
      width="80%"
      style="z-index: 100"
      v-model="modalResult"
      :title="
        $t('transferProdResult') + ' ' + $store.state.produksi.toUpperCase()
      "
      height="80%"
      show-zoom
      show-footer
      resize
    >
      <template #default>
        <vxe-table
          size="mini"
          :loading="loadingTableWh"
          empty-text="Empty Data "
          keep-source
          border
          @filter-change="changeFilter"
          show-overflow
          show-header-overflow
          ref="xTableResult"
          height="500"
          row-key
          highlight-hover-row
          highlight-current-row
          :row-config="{ isCurrent: true, isHover: true, height: 35 }"
          :column-config="{ resizable: true }"
          :data="contacts"
          :mouse-config="{ selected: true }"
          :checkbox-config="{
            highlight: true,
            range: true,
          }"
          :keyboard-config="{
            isArrow: true,
            isDel: true,
            isEnter: true,
            isTab: true,
            isEdit: true,
          }"
          :edit-config="{
            trigger: 'dblclick',
            mode: 'cell',
            showStatus: true,
          }"
          :scroll-y="{ mode: 'wheel' }"
        >
          <vxe-column type="seq" fixed="left" width="60"></vxe-column>
          <vxe-column
            align="center"
            header-align="center"
            width="150"
            field="button"
            title="SELECT"
            sortable
          >
            <template #default="{ row }">
              <el-button
                size="mini"
                type="primary"
                @click="handleSelected(row)"
              >
                Select
              </el-button>
            </template>
          </vxe-column>
          <vxe-column
            align="left"
            header-align="center"
            width="150"
            field="tanggal"
            :formatter="$$formatDate"
            :title="$t('dateProd').toUpperCase()"
            sortable
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
          >
            <template #filter="{ $panel, column }">
              <input
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                style="padding: 5px"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              />
            </template>
          </vxe-column>

          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="150"
            field="noReg"
            :title="$t('noRegi').toUpperCase()"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="150"
            field="noWo"
            :title="$t('noPO').toUpperCase()"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>

          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="150"
            field="kodeBarang"
            :title="$t('kodeBarang').toUpperCase()"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="200"
            field="namaBarang"
            :title="$t('itemDeskripsi').toUpperCase()"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="120"
            field="style"
            :title="$store.state.styleName"
            v-if="$store.state.availableStyle"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="120"
            field="color"
            :title="$store.state.colorName"
            v-if="$store.state.availableColor"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="120"
            field="size"
            :title="$store.state.sizeName"
            v-if="$store.state.availableSize"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>
          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="left"
            header-align="center"
            width="120"
            field="spec"
            :title="$store.state.specName"
            v-if="$store.state.availableSpec"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>

          <vxe-column
            :filters="[{ data: '' }]"
            :filter-method="$$filterHeaderTable"
            align="center"
            header-align="center"
            width="100"
            field="satuan"
            :title="$t('satuan').toUpperCase()"
            sortable
          >
            <template #filter="{ $panel, column }">
              <input
                style="padding: 5px"
                type="type"
                v-for="(option, index) in column.filters"
                :key="index"
                v-model="option.data"
                @input="$panel.changeOption($event, !!option.data, option)"
              /> </template
          ></vxe-column>

          <vxe-column
            align="right"
            header-align="center"
            width="140"
            field="qty"
            :formatter="$$formatAmountBc"
            :title="$t('qtyHasil').toUpperCase()"
            sortable
          >
          </vxe-column>
          <vxe-column
            align="right"
            header-align="center"
            width="140"
            field="qtyUse"
            :formatter="$$formatAmountBc"
            :title="$t('qtyTransfer').toUpperCase()"
            sortable
          >
          </vxe-column>
          <vxe-column
            align="right"
            header-align="center"
            width="140"
            field="total"
            :title="$t('qtyBalance').toUpperCase()"
            sortable
          >
            <template #default="{ row }">
              <p>
                {{ $formatAngka(row.qty - row.qtyUse) }}
              </p>
            </template>
          </vxe-column>
          <vxe-column
            align="right"
            header-align="center"
            width="140"
            field="jenisDokumenBc"
            title="ASAL JENIS DOKUMEN"
            sortable
          >
          </vxe-column>
          <vxe-column
            align="right"
            header-align="center"
            width="140"
            field="nomorDokumenBc"
            title="ASAL NOMOR DOKUMEN"
            sortable
          >
          </vxe-column>
        </vxe-table>
      </template>
      <template #footer>
        <template class="justify-center">
          <el-button v-on:click="modalResult = false">
            {{ $t("close") }}
          </el-button>
        </template>
      </template>
    </vxe-modal>
    <ApprovePin @submit="terimaDataApprove" ref="approvePin" />
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "axios";

import "vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import Datepicker from "vuejs-datepicker";
import XLSX from "xlsx";
import moment from "moment";
import SelectBarang from "../../components/other/SelectBarang.vue";
import ApprovePin from "../../../components/approve/ApprovePin.vue";

export default {
  props: {
    test: String,
    method: {
      type: Function,
    },
  },
  components: {
    vSelect,
    ApprovePin,
    SelectBarang,

    SweetModal,
    SweetModalTab,
    Datepicker,
  },
  data() {
    return {
      modalResult: false,
      loadingTable: false,
      loadingTableWh: false,
      loadingTableWhSelect: false,
      dataJo: [],
      dataHalf: [],
      shortcuts: [
        {
          text: "Today",
          onClick() {
            const date = new Date();
            // return a Date
            return date;
          },
        },
        {
          text: "Yesterday",
          onClick() {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            return date;
          },
        },
      ],
      form: {
        tanggal: new Date(),
        noWo: "",
        department: "",
        remark: "",
        tujuan: "",
      },
      isJo: false,
      selectJoheader: [],
      joNumber: "",
      dataMaterial: [],
      optionDepartment: [],
      department: "",
      index: "",
      tglOrderAwal: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      tglOrderAkhir: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      tglAwal: new Date(),
      tglAkhir: new Date(),
      tglAwalWh: new Date(),
      tglAkhirWh: new Date(),
      contacts: [],
      selectPo: [],

      dataHf: [],
      user: "",
      pilihOrdernumber: "",
      dataOrdernumber: [],

      focuskurs: false,
      format: "yyyy-MM-dd",
      wodata: [],
      optionPemasok: [],
      optionStatus: [
        {
          text: "Active",
          value: "active",
        },
        {
          text: "Inactive",
          value: "inactive",
        },
      ],
      pilihMaterial: [],
      pilihMaterial2: [],

      submitted: false,
      searchQuery: "",
      dataBarangjadi: [],
      dataKomposisiWo: [],
      dataMaterial: [],
      selectBarangJadi: [],
      val: "",
      pemasok: "",
      noreg: "",

      tglPo: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      dueDate: new Date().toLocaleString("en-US", {
        timeZone: "Asia/Jakarta",
      }),
      noPo: null,
      ketOrder: "",
      optionPilihan: [
        { text: "WO", value: "jo" },
        { text: "Master", value: "master" },
      ],
      pilihan: "",
      tr: [],
      keterangan: "",
      status: "",
      optionKalkulasi: [],
      baca: [],
      excelData: [],
      pilihOrder: [],
      detailUpdate: [],
    };
  },
  watch: {},
  computed: {
    validName() {
      return (
        this.valMultipe.kategori.length > 0 && this.valMultipe.jenis.length > 0
      );
    },
  },
  methods: {
    async changeFilter({
      column,
      property,
      values,
      datas,
      filterList,
      $event,
    }) {
      if (filterList.length == 0) {
        this.getPo();
        return;
      }
      let dataSearch = {};
      for (let elm of filterList) {
        dataSearch[elm.field] = elm.datas[0];
      }
      this.getPo(dataSearch);
    },
    async validationQty(row) {
      let get = await this.$api.get(
        "api/v1/production/transfer/findvalidationqty",
        {
          params: {
            idAsal: row.idAsal,
          },
        }
      );
      let qtyUseUpdate = this.detailUpdate
        .filter((f) => f.idAsal == row.idAsal)
        .reduce((pv, cv) => {
          return pv + cv.qty;
        }, 0);
      let sisaDb = get.data.content.sisa;

      let qtyUseAll = this.baca
        .filter((f) => f.idAsal == row.idAsal)
        .reduce((pv, cv) => {
          return parseFloat(pv) + parseFloat(cv.qty);
        }, 0);
      let qtyUseAllExcept = this.baca
        .filter((f) => f._X_ROW_KEY != row._X_ROW_KEY)
        .reduce((pv, cv) => {
          return parseFloat(pv) + parseFloat(cv.qty);
        }, 0);

      let totalStok =
        parseFloat(sisaDb) + parseFloat(qtyUseUpdate) - parseFloat(qtyUseAll);

      console.log(parseFloat(sisaDb + qtyUseUpdate), this.detailUpdate);
      if (totalStok < 0) {
        this.notifValidasi("Stok tidak bisa melebihi batas", true);
        row.qty = parseFloat(totalStok) + parseFloat(row.qty);
      }
      setTimeout(() => {
        this.$refs.xTable.updateFooter();
      }, 100);
    },
    rowStyle({ row }) {
      if (row.isDeleted) {
        return {
          backgroundColor: "red",
          color: "white",
        };
      }
    },
    hapusRow(row) {
      if (!row.id) {
        this.baca = this.baca.filter((f) => f._X_ROW_KEY != row._X_ROW_KEY);
        return;
      }
      if (!row.isDeleted) {
        row.isDeleted = true;
        return;
      }
      if (row.isDeleted) {
        row.isDeleted = false;
        return;
      }
    },
    setFormValue(data) {
      data.tanggal = new Date(data.tanggal);
      data.tujuan = data.namaProsesTujuan;
      this.detailUpdate = [...data.listDetail];
      this.form = data;
      this.form.department = this.$store.state.produksi;
      this.baca = [...data.listDetail];
    },
    footerMethod({ columns, data }) {
      const footerData = [
        columns.map((column, _columnIndex) => {
          if (_columnIndex === 0) {
            return "TOTAL";
          }
          if (
            [
              "qty",
              "qtyUse",
              "qtyGradeB",
              "qtyUseGradeB",
              "qtyGradeC",
              "qtyUseGradeC",
              "price",
              "amount",
            ].includes(column.property)
          ) {
            data.forEach((e) => {
              e.amount = e.qty * e.price;
            });
            return this.$formatAmountBc(this.$$sumNum(data, column.property));
          }
          return null;
        }),
      ];
      return footerData;
    },
    async getHalf() {
      try {
        const response = await this.$api.get(
          "api/v1/production/receiving/warehouse",
          {
            params: { department: "warehouse" },
          }
        );
        // console.log(response);
        this.dataHalf = response.data.content.sort(
          this.compareValues("id", "desc")
        );
      } catch (error) {
        console.log(error);
      }
    },
    inputQty(row) {
      if (row.qty > row.qtyBalance) {
        this.$vs.notify({
          title: this.$t("gagal"),
          text: "Tidak Bisa Melebihi Batas",
          color: "danger",
        });
        row.qty = row.qtyBalance;
      }
    },
    inputTujuan() {
      console.log(this.form.tujuan);
      if (this.form.tujuan == this.$store.state.produksi) {
        this.notifValidasi(
          "Tidak Bisa memilih tujuan yang sama dengan department saat ini, Silahkan Pilih destinasi/tujuan lain. ",
          true
        );
        this.form.tujuan = null;
        return;
      }
    },
    approvePin() {
      this.$vs.dialog({
        type: "confirm",
        color: "primary",
        title: `Konfirmasi`,
        text: "Yakin Simpan data?",
        accept: async () => {
          this.submitedData();
        },
      });
      // this.$refs.approvePin.showModal();
    },
    async terimaDataApprove(val) {
      let checkApprove = this.$$checkApproval(
        val.list,
        val.data,
        "materialtransfer"
      );
      if (checkApprove == true) {
        this.notifikasiCustom("success", "BERHASIL", "Submit Trasaction");
        this.submitedData(val.data);
        this.loadingTable = false;

        return;
      }
    },
    modalBarangShow() {
      this.$refs.modalMaterial.showModal();
    },
    selectedItem(row) {
      let elm = { ...row };
      delete elm.id;
      elm.kodeBarang = elm.kodeBarang;
      elm.noWo = this.form.noWo;
      elm.namaBarang = elm.namaBarang;
      elm.qty = 0;
      this.baca.push(elm);
      this.$vs.notify({
        color: "success",
        title: this.$t("berhasil"),
        text: "Pilih Barang",
      });
    },
    detailtoisdeletedTrue() {
      let data = this.$refs.xTable.getCheckboxRecords();
      data.forEach((e) => {
        this.baca = this.baca.filter((f) => f._X_ROW_KEY != e._X_ROW_KEY);
      });
      // this.$refs.xTable.removeCheckboxRow();
      this.$notify({
        type: "success",
        offset: 200,
        message: "Success Delete row",
        title: "SUCCESS",
      });
    },
    formatterNum({ cellValue }) {
      return this.$formatAngka(cellValue);
    },
    getDataSelected() {},

    editMethod({ row, column }) {
      this.$refs.xTable.setActiveCell(row, column.property);
      return false;
    },
    selectedHalf() {
      this.notifikasiCustom("success", "SUCCESS", "SELECTED");
      let selected = this.$refs.xTableReceiv.getCheckboxRecords();

      this.baca = [];
      selected.forEach((e) => {
        let newElm = { ...e };
        newElm.noRegProd = e.noReg;

        newElm["qty"] = e.qty - e.qtyUse;
        newElm["qtyBalance"] = e.qty - e.qtyUse;

        newElm.idAsal = e.id;
        newElm.noWo = e.noWo;

        delete newElm.id;
        delete newElm._X_ROW_KEY;
        this.baca.push(newElm);
      });
    },
    handleSelected(tr) {
      let check = this.baca.find((f) => f.idAsal == tr.id);
      if (check) {
        this.notifValidasi("Data sudah dipilih", true);
        return;
      }
      this.notifikasiCustom("success", "SUCCESS", "SELECTED");

      let newElm = { ...tr };
      newElm.noRegProd = tr.noReg;
      newElm.dateProd = tr.tanggal;

      newElm["qty"] = tr.qty - tr.qtyUse;
      newElm["qtyBalance"] = tr.qty - tr.qtyUse;

      newElm.idAsal = tr.id;
      newElm.noWo = tr.noWo;

      delete newElm.id;
      delete newElm._X_ROW_KEY;
      this.baca.push(newElm);
    },
    cekTanggal() {
      if (this.tglAwal > this.tglAkhir) {
        this.tglAwal = this.tglAkhir;
        this.$vs.notify({
          text: this.$t("silahkanPilihTanggalYangSesuai"),
          color: "warning",
        });
      } else {
        this.getPo();
      }
    },

    notifwarning(title, text) {
      this.$vs.notify({
        color: "danger",
        title: title,
        text: text,
      });
    },
    async submitedData(approve) {
      let dataPost = [];
      let dept = await this.$$getOptionProeses();
      dept.push(
        { kodeProses: "warehouse", namaProses: "warehouse" },
        { kodeProses: "subkon", namaProses: "subkon" },
        {
          kodeProses: "ppbkb",
          namaProses: "ppbkb",
        }
      );
      let asal = dept.find(
        (f) => f.namaProses.toLowerCase() == this.$store.state.produksi
      );
      if (this.form.tujuan) {
        let tujuan = dept.find(
          (f) => f.namaProses.toLowerCase() == this.form.tujuan.toLowerCase()
        );
        if (tujuan) {
          this.form.kodeProsesTujuan = tujuan.kodeProses;
          this.form.namaProsesTujuan = tujuan.namaProses;
        }
      }
      if (asal) {
        this.form.kodeProses = asal.kodeProses;
        this.form.namaProses = asal.namaProses;
      }

      for (const elm of this.baca) {
        let newElm = {
          idAsal: elm.idAsal,
          noWo: elm.noWo,
          noRegWo: elm.noRegWo,
          noRegProd: elm.noRegProd,
          dateProd: elm.dateProd,
          isDeleted: elm.isDeleted,
          kodeBarang: elm.kodeBarang,
          namaBarang: elm.namaBarang,
          kodeFG: elm.kodeBarang,
          jenisBc: elm.jenisBc,
          department: this.form.department,
          kodeProses: this.form.kodeProses,
          namaProses: this.form.kodeProses,
          kodeProsesTujuan: this.form.kodeProsesTujuan,
          namaProsesTujuan: this.form.namaProsesTujuan,
          user: this.$store.state.userEmail,
          spec: elm.spec,
          style: elm.style,
          color: elm.color,
          size: elm.size,
          kategori: elm.kategori,
          status: "new",
          satuan: elm.satuan,
          jenisDokumenBc: elm.jenisDokumenBc,
          nomorDokumenBc: elm.nomorDokumenBc,
          idAsalIncoming: elm.idAsalIncoming,
          qty: elm.qty,
          isComplete: !elm.isComplete ? false : elm.isComplete,
          qtyUse: !elm.qtyUse ? 0 : elm.qtyUse,
          tglTransfer: new Date(this.form.tglTransfer),
          tanggal: new Date(this.form.tglTransfer),

          user: this.$store.state.userEmail,
        };
        dataPost.push(newElm);
      }
      this.form.listDetail = dataPost;

      this.$emit("submitedData", this.form);
    },

    acceptAlert() {
      // this.close();
      this.$vs.notify({
        color: "success",
        title: this.$t("berhasil"),
        text: "Berhasil Menambahakan Data",
      });
    },
    close() {
      this.clearValMultiple();
      this.$vs.notify({
        color: "danger",
        title: this.$t("gagal"),
        text: "Batal Menambahkan Dataa!",
      });
    },
    clearValMultiple() {
      this.valMultipe.kodeBarang = "";
      this.valMultipe.namaBarang = "";
      this.valMultipe.kategori = "";
      this.valMultipe.jenis = "";
    },

    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          // property doesn't exist on either object
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },

    async getPo(filter) {
      this.baca = [];

      try {
        // const response = await this.$api.get(
        //   `/api/v1/production/production/result/notequals`,
        //   {
        //     params: {
        //       department: this.$store.state.produksi,
        //     },
        //   }
        // );
        const response = await this.$api.get(
          this.$serviceApi + `produksi/result`,
          {
            params: {
              department: this.$store.state.produksi,
              ...filter,
            },
          }
        );

        this.contacts = response.data.content;
      } catch (e) {
        console.log(error);
      }
    },
    radioChangeEvent({ row }) {
      console.log(row);
      this.form.noWo = row.noWo;
    },
    async getWh() {
      let tglawal = moment(this.tglAwalWh).format("yyyy-MM-DD");
      let tglakhir = moment(this.tglAkhirWh).format("yyyy-MM-DD");
      try {
        const response = await this.$api.get(
          `/api/v1/ppic/jodetail/findbydate?start=${tglawal}&end=${tglakhir}`
        );

        this.dataJo = response.data.content;
      } catch (e) {
        console.log(error);
      }
    },
  },

  async mounted() {
    if (this.$route.params.id == undefined) {
      this.$router.push("/");
    } else {
      this.$checkParamsProduksi(this.$route.params.id);
      this.$store.commit("setProduksi", this.$route.params.id);
    }
    this.form.department = this.$store.state.produksi;

    var date = new Date();
    date.setDate(date.getDate() - 1);
    this.tglAwal = date;
    this.tglAwalWh = date;
    if (this.$store.state.produksi != "warehouse") {
      this.getPo();
    } else {
      this.getHalf();
    }

    // this.getWh();

    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1; // "+ 1" becouse the 1st month is 0
    var day = date.getDate();
    var hour = date.getHours();
    var minutes = date.getMinutes();
    var sec = date.getSeconds();

    var seedatetime =
      "TRF-PRD-" + year + month + day + "-" + hour + minutes + sec;

    this.form.noReg = seedatetime;
    // this.$refs.modal.open();

    let proses = await this.$$getOptionProeses();
    proses.forEach((elm) => {
      if (elm.namaProses.toLowerCase() != this.$store.state.produksi) {
        this.optionDepartment.push({
          text: elm.namaProses,
          value: elm.namaProses,
        });
      }
    });
    this.optionDepartment.push(
      {
        text: "warehouse",
        value: "warehouse",
      },
      {
        text: "subkon",
        value: "subkon",
      }
    );

    if (this.$store.state.fastProduction) {
      this.optionDepartment = [
        {
          text: "subkon",
          value: "subkon",
        },
      ];
    }
    if (
      this.$store.state.produksi == "finishgoods" &&
      this.$store.state.ppbkbMenu
    ) {
      this.optionDepartment = [
        {
          text: "ppbkb",
          value: "ppbkb",
        },
      ];
    }

    //
  },
};
</script>
